
import axios from '../config/axios';

export const url = '/api/contacto3xpgy'


export const createcontacto3xpgy = ({
  token,
	nombremzbcy,
	correoznnk,
	telefonoiahke,
	organizacin7a8awi,
	mensajed8wp2j,
	loftyFile,

}) => new Promise((resolve, reject) => {
  if (token && nombremzbcy && correoznnk && telefonoiahke && organizacin7a8awi ) {

    axios.post(`${url}//create/basic/6931c257e30724925008b21c`, {
		nombremzbcy,
		correoznnk,
		telefonoiahke,
		organizacin7a8awi,
		mensajed8wp2j,

    }, {
      headers: {
        
        AuthorizationApp: token,
      }
    }).then((res) => {
      const {data} = res;
      if (data.status === 'success') {
        resolve(data);
      } else {
        reject(data);
      }
    }).catch(error => reject(error));
  } else if (!nombremzbcy) {
		reject({
			status: 'error',
			info: 'Nombre no esta definido',
		});
	}  else if (!correoznnk) {
		reject({
			status: 'error',
			info: 'Correo no esta definido',
		});
	}  else if (!telefonoiahke) {
		reject({
			status: 'error',
			info: 'Telefono no esta definido',
		});
	}  else if (!organizacin7a8awi) {
		reject({
			status: 'error',
			info: 'Organización no esta definido',
		});
	}  else {
    reject({
      status: 'error',
      info: 'Token no definido'
    });
  }
});
      

